var translations = {
  "en": {
    "description": "Description",
    "selectDate": "Select a Date",
    "timeslot": "Available Times",
    "buy": "Buy Tickets"
  },
  "de": {
    "description": "Beschreibung",
    "selectDate": "Wählen Sie ein Datum",
    "timeslot": "Erhältliche Zeiten",
    "buy": "Tickets Kaufen"
  }
};
